import fr from "../assets/lang/fr.json";
import en from "../assets/lang/en.json";
import {api} from "@/services/Api";
import store from "@/store";
import {helper} from "@/services/Helper";
import {auth} from "@/services/Auth";


class Translator {
    dico: any = {};
    public unknows: string[] = []
    public to: any = null
    public loaded = false
    public delay = 2000
    public source = 'admin'
    public subFolder = 'wia/frontend/admin/src/assets/lang/'

    constructor() {
        this.dico = {fr, en}
        // Setup du listener load
        const onLoad = () => {
            clearTimeout(this.to);
            this.to = null;
            this.loaded = true;
            window.removeEventListener('load', onLoad);
        };

        window.addEventListener('load', onLoad);
    }

    private onLoad = () => {
        clearTimeout(this.to);
        this.to = null;
        this.loaded = true;
    }

    async init() {
        const res = await api.get(api.core, 'shared/trans/admin/' + store.state.mainStore.lang)
        if(res && res.data && res.data.dico){
            this.dico[store.state.mainStore.lang] = JSON.parse(res.data.dico)
        }
    }

    translate(code: string) {
        if (!code || helper.empty(code)) {
            return '';
        }

        const result = code.replace(/_/g, ' ');
        if(this.dico.hasOwnProperty(store.state.mainStore.lang)){
            const dico = this.dico[store.state.mainStore.lang]
            if (!Object.prototype.hasOwnProperty.call(dico, code)) {
                Object.assign(dico, {[code]: result});
                clearTimeout(this.to)
                this.to = null
                return result;
            } else {
                return dico[code];
            }
        }else{
            console.log('Dictionnaire inconnu "'+store.state.mainStore.lang+'"')
        }
    }

    async saveUnknow() {
        if(!auth.hasRole('ROLE_MANAGER')){
            return
        }
        clearTimeout(this.to)
        this.to = null
        if (this.unknows.length > 0) {
            // code commenté...
        }
    }

    // Méthode de cleanup pour libérer les ressources
    public destroy() {
        window.removeEventListener('load', this.onLoad);
        clearTimeout(this.to);
        this.to = null;
        this.unknows = [];
    }
}

export const trans = new Translator();